import {ApiManager} from "@/stores/api/ApiManager";

class BOAuthService {

  constructor(){
    this.url = "bo-auth"
  }

  async getMagicLink(payload = {}) {
    const apiManager = new ApiManager(this.url);
    return await apiManager.call(payload);
  }
}

export default new BOAuthService()